// External Libraries
import * as React from "react";
import { formatText, formatDateString } from "bernie-l10n";
import TruncatedText from "shiitake";

// Types
import { Hotel } from "typings/microserviceModels/hotels-flex-module";

// UITK
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";

// Components
import { ReviewCountAndRating } from "components/flexComponents/Hotels/components/ReviewCountAndRating";
import { showReviewCountAndRating } from "components/flexComponents/Hotels/components/FeaturedReviewContent";
import { useHotelsContext } from "components/flexComponents/Hotels/components/HotelsContext";

// Utils
import { getAddress } from "components/flexComponents/Hotels/utils/getAddress";
import PriceLockup from "../../views/HotelsViews/components/shared/PriceLockup";
import { HotelPriceLockupWithDates } from "../../utils/A11y/HotelPriceLockupWithDates";

interface SummarizedContentProps {
  hotel: Hotel;
  isMobile: boolean;
}

export const SummarizedContent: React.FC<SummarizedContentProps> = ({ hotel }) => {
  const { hotelName, reviewCount, hotelOverallReviewRating, featuredReviews } = hotel;
  const {
    context,
    flexComponent: {
      model: { showGuestRating },
    },
  } = useHotelsContext();

  const language = context.locale?.split(/[_-]/);

  return (
    <section className="uitk-card-text-segment uitk-flex uitk-flex-column uitk-flex-justify-content-space-between">
      <UitkLayoutFlex justifyContent="space-between">
        <UitkLayoutFlexItem shrink={1} className="all-r-margin-one">
          <div>
            <div className="uitk-type-600 uitk-type-bold all-b-padding-one">
              <span className="uitk-type-heading-500" data-testid="hotel-name">
                <TruncatedText renderFullOnServer={true} lines={2}>
                  {hotelName}
                </TruncatedText>
              </span>
            </div>
            <div className="uitk-type-300 all-b-padding-one">{getAddress(hotel)}</div>
          </div>
        </UitkLayoutFlexItem>
        <UitkLayoutFlexItem shrink={0}>
          <PriceLockup hotel={hotel} priceA11y={new HotelPriceLockupWithDates(hotel, formatText, formatDateString)} />
        </UitkLayoutFlexItem>
      </UitkLayoutFlex>
      {showReviewCountAndRating(showGuestRating, reviewCount, hotelOverallReviewRating, featuredReviews) && (
        <ReviewCountAndRating
          hotelOverallReviewRating={hotelOverallReviewRating}
          reviewCount={reviewCount}
          language={language}
        />
      )}
    </section>
  );
};
